module.exports = __webpack_public_path__ + "static/media/gora-l.15d3c064.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ResizableProduct/images/gora-l.png
// module id = 435
// module chunks = 0